(function(){
  function esc(v){ return String(v || '').replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[c];}); }
  document.querySelectorAll('.t100parts[data-t100parts]').forEach(function(root){
    var browser = root.querySelector('[data-t100-browser]');
    var systems = root.querySelector('.t100parts__systems');
    var workspace = root.querySelector('.t100parts__workspace');
    var select = root.querySelector('[data-t100-assembly]');
    var search = root.querySelector('.t100parts__search');
    var parts = window.TJAT100Parts || [];
    if (!browser || !systems || !workspace || !select || !parts.length) return;

    var nav = document.createElement('div');
    nav.className = 't100parts__assemblyQuick';
    nav.innerHTML = '<div class="t100parts__assemblyQuickHead"><strong>Browse assemblies</strong><span>Tap an assembly to open its exact diagram and parts list.</span></div><div class="t100parts__assemblyQuickList" data-t100-assembly-quick-list></div>';
    systems.insertAdjacentElement('afterend',nav);
    var list = nav.querySelector('[data-t100-assembly-quick-list]');

    function activeGroup(){
      var active = root.querySelector('.t100parts__system.is-active[data-group]');
      return active ? active.dataset.group : 'spray';
    }
    function assembliesFor(group){
      var seen = new Set();
      var out = [];
      parts.forEach(function(p){
        if (p.g !== group || seen.has(p.a)) return;
        seen.add(p.a);
        out.push(p.a);
      });
      return out;
    }
    function positionCount(group, assembly){
      return parts.filter(function(p){ return p.g === group && p.a === assembly; }).length;
    }
    function render(){
      var group = activeGroup();
      var current = select.value || '';
      list.innerHTML = assembliesFor(group).map(function(name){
        var count = positionCount(group,name);
        var active = name === current;
        return '<button type="button" class="t100parts__assemblyQuickBtn'+(active?' is-active':'')+'" aria-pressed="'+(active?'true':'false')+'" data-t100-quick-assembly="'+esc(name)+'"><strong>'+esc(name)+'</strong><small>'+count+' diagram position'+(count===1?'':'s')+'</small></button>';
      }).join('');
    }
    function syncActive(){
      var current = select.value || '';
      list.querySelectorAll('[data-t100-quick-assembly]').forEach(function(btn){
        var active = btn.dataset.t100QuickAssembly === current;
        btn.classList.toggle('is-active',active);
        btn.setAttribute('aria-pressed',active ? 'true' : 'false');
      });
    }

    systems.addEventListener('click',function(){ setTimeout(render,0); });
    select.addEventListener('change',function(){ setTimeout(syncActive,0); });
    list.addEventListener('click',function(e){
      var btn = e.target.closest('[data-t100-quick-assembly]');
      if (!btn) return;
      if (search && search.value) {
        search.value = '';
        search.dispatchEvent(new Event('input',{bubbles:true}));
      }
      select.value = btn.dataset.t100QuickAssembly;
      select.dispatchEvent(new Event('change',{bubbles:true}));
      setTimeout(function(){
        syncActive();
        var panel = root.querySelector('.t100parts__diagramPanel');
        if (panel) panel.scrollIntoView({behavior:'smooth',block:'start'});
      },0);
    });
    render();
  });
})();
